import { Currency, getCurrencySymbol } from "@redotech/money/currencies";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const CoverageSharePreview = memo(function CoverageSharePreview({
  coveragePrice,
  currency,
  percentValue,
}: {
  coveragePrice: number;
  currency: Currency;
  percentValue: string;
}) {
  if (coveragePrice <= 0) {
    return (
      <Text fontSize="xxs" textColor="tertiary">
        Set coverage pricing to preview the amount per covered order.
      </Text>
    );
  }

  const percent = parsePercent(percentValue);
  const shareAmount = (percent / 100) * coveragePrice;

  return (
    <Text fontSize="xxs" textColor="tertiary">
      {`${formatPercent(percent)} of ${formatCurrencyAmount(
        coveragePrice,
        currency,
      )} coverage = ${formatCurrencyAmount(
        shareAmount,
        currency,
      )} per covered order`}
    </Text>
  );
});

function parsePercent(value: string): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatPercent(value: number): string {
  return `${Number(value.toFixed(2))}%`;
}

function formatCurrencyAmount(value: number, currency: Currency): string {
  const symbol = getCurrencySymbol(currency);
  const roundedValue = Math.round((value + Number.EPSILON) * 100) / 100;
  const currencySuffix =
    currency !== Currency.USD && symbol === "$" ? ` ${currency}` : "";
  return `${symbol}${roundedValue.toFixed(2)}${currencySuffix}`;
}
